if (document.querySelector(".meganav__collect") != null) {
  Array.from(document.querySelectorAll(".meganav__collect")).forEach((container) => {
      let items = container.querySelectorAll(".meganav__collect-first-link");
      let cardImgs = container.querySelectorAll(".meganav__secondary");
      items.forEach((item) => {
        item.addEventListener("mouseover", (e) => {
          const index = item.getAttribute("data-val");
          cardImgs.forEach((cardImg) => {
            if (cardImg.getAttribute("data-val") == index) {
              cardImg.classList.add("selected");
            } else {
              cardImg.classList.remove("selected");
            }
          });
          items.forEach((curItem) => {
            if (curItem != item) {
              curItem.classList.remove("selected");
            }
          });
          item.classList.add("selected");
        });
      });
      if (items.length > 0) {
        items[0].classList.add("selected");
        const index = items[0].getAttribute("data-val");
        cardImgs.forEach((cardImg) => {
          if (cardImg.getAttribute("data-val") == index) {
            cardImg.classList.add("selected");
          } else {
            cardImg.classList.remove("selected");
          }
        });
      }
  });
}
if (document.querySelector(".mt-red-wall__container") != null) {
  Array.from(document.querySelectorAll(".mt-red-wall__container")).forEach((container) => { 
      container.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        selectImg(1);
      });
      container.querySelector(".slider-button--next").addEventListener('click', (e) => {
        selectImg(-1);
      });
      let itemSelects = Array.from(container.querySelectorAll(".mt-red-wall__item"));
      let firstLeft = itemSelects[0].offsetLeft;
      let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
      function selectImg(val){ 
        let curLeft = container.querySelector(".mt-red-wall__items").scrollLeft;
        let moveX =  -1 * curLeft % leftX;
        if(itemSelects != null && itemSelects.length > 1){
          moveX = (leftX - moveX) * val;
        }
        container.querySelector(".mt-red-wall__items").scrollLeft = curLeft - moveX;
      }
  });
}


if (document.querySelector(".mt-slide-products-container") != null) {
  Array.from(document.querySelectorAll(".mt-slide-products-container")).forEach((container) => {  
      let maxVal = parseInt(container.querySelector(".mt-slide-products-item").getAttribute("max-index"));
      let rheaders = container.querySelectorAll(".mt-slide-products-rtop-header");
      container.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        let val = parseInt(container.querySelector(".mt-slide-products-item").getAttribute("data-index"));
        if(val > 0){       
          val = val - 1;
          container.querySelector(".mt-slide-products-item").setAttribute("data-index", val);
          rheaders.forEach((rheader) => {
            if(rheader.getAttribute("data-index") == val){
              rheader.classList.add("selected");
            }else{
              rheader.classList.remove("selected");
            }
          });         
        }
        selectImg(1);
        selectRight(1);
      });
      container.querySelector(".slider-button--next").addEventListener('click', (e) => {
        let val = parseInt(container.querySelector(".mt-slide-products-item").getAttribute("data-index"));
        if(val < maxVal){ 
          val = val + 1;
          container.querySelector(".mt-slide-products-item").setAttribute("data-index", val);
          rheaders.forEach((rheader) => {
            if(rheader.getAttribute("data-index") == val){
              rheader.classList.add("selected");
            }else{
              rheader.classList.remove("selected");
            }
          });  
        }
        selectImg(-1);
        selectRight(-1);
      });
      rheaders.forEach((rheader) => {
        rheader.addEventListener("click", (e) => {
          rheaders.forEach((curItem) => {
            if(rheader == curItem){
              curItem.classList.add("selected");
            }else{
              curItem.classList.remove("selected");
            }   
          });
          let val = parseInt(container.querySelector(".mt-slide-products-item").getAttribute("data-index"));
          let moveVal = parseInt(rheader.getAttribute("data-index"));
          if(window.innerWidth < 750){
            selectMbImg(val- moveVal);
          }else{
            selectImg(val - moveVal);
          }       
          selectRight(val - moveVal);
          container.querySelector(".mt-slide-products-item").setAttribute("data-index", moveVal);
        });
      });
      let itemSelects = Array.from(container.querySelectorAll(".mt-slide-products-left-image"));  
      let firstLeft = itemSelects[0].offsetLeft;
      let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
      function selectImg(val){ 
        let curLeft = container.querySelector(".mt-slide-products-left-images").scrollLeft;
        let moveX =  -1 * curLeft % leftX;
        if(itemSelects != null && itemSelects.length > 1){
          moveX = (leftX - moveX) * val;
        }
        container.querySelector(".mt-slide-products-left-images").scrollLeft = curLeft - moveX;
      }

      let mbSelects = Array.from(container.querySelectorAll(".mt-slide-products-rcenter-image"));  
      let mbLeftX = mbSelects[1].offsetLeft - mbSelects[0].offsetLeft;  
      function selectMbImg(val){ 
        let curLeft = container.querySelector(".mt-slide-products-rcenter-images").scrollLeft;
        let moveX =  -1 * curLeft % mbLeftX;
        if(mbSelects != null && mbSelects.length > 1){
          moveX = (mbLeftX - moveX) * val;
        }
        container.querySelector(".mt-slide-products-rcenter-images").scrollLeft = curLeft - moveX;
      }

      let rightSelects = Array.from(container.querySelectorAll(".mt-slide-products-rbottom-item"));
      let rightSelect = rightSelects[0].offsetLeft;
      let rightLeftX = rightSelects[1].offsetLeft - rightSelects[0].offsetLeft;  
      function selectRight(val){ 
        let curLeft = container.querySelector(".mt-slide-products-rbottom-items").scrollLeft;
        let moveX =  -1 * curLeft % rightLeftX;
        if(rightSelects != null && rightSelects.length > 1){
          moveX = (rightLeftX - moveX) * val;
        }
        container.querySelector(".mt-slide-products-rbottom-items").scrollLeft = curLeft - moveX;
      }
  });
}

if (document.querySelector(".video-hero") != null) {
  Array.from(document.querySelectorAll(".video-hero")).forEach((container) => { 
      const videoPause =  container.querySelector(".video-pause");
      videoPause.addEventListener('click', (e) => {
        const stopi = videoPause.querySelector(".icon-stop");
        const starti = videoPause.querySelector(".icon-start");
        if(stopi != null && starti != null){
          if(stopi.classList.contains("unshow")){
            stopi.classList.remove("unshow");
            starti.classList.add("unshow");
            container.querySelector(".video-hero__text-image").classList.add("unshow");
          }else{
            stopi.classList.add("unshow");
            starti.classList.remove("unshow");
          }
        }
      });        
  });
  window.addEventListener('load', function(event) {
    Array.from(document.querySelectorAll(".video-hero")).forEach((heros) => { 
          heros.querySelector(".video-hero__video").pause();
    });      
  });
}


/** mt-image-list **/
Array.from(document.querySelectorAll(".mt-image-list__container")).forEach((container) => { 
    let btns = container.querySelector(".slider-buttons");                                                                                                                                                                                                          
    btns.querySelector(".slider-button--prev").addEventListener('click', (e) => {
        selectContent(1);
    });
    btns.querySelector(".slider-button--next").addEventListener('click', (e) => {
        selectContent(-1);
    });
    let itemSelects = Array.from(container.querySelectorAll(".mt-image-list__item"));
    let firstLeft = itemSelects[0].offsetLeft;
    let leftX = itemSelects[1].offsetLeft - itemSelects[0].offsetLeft;  
    function selectContent(val){ 
      let curLeft = container.querySelector(".mt-image-list__items").scrollLeft;
      let moveX =  -1 * curLeft % leftX;

      if(itemSelects != null && itemSelects.length > 1){
        moveX = (leftX - moveX) * val;
      }
      container.querySelector(".mt-image-list__items").scrollLeft = curLeft - moveX;
    }
});
/** mt-image-list **/


/** mt-card-list **/
Array.from(document.querySelectorAll(".mt-card-list__container")).forEach((container) => { 
    const tp1 = container.querySelector(".mt-card-list__tp1");
    const tp2 = container.querySelector(".mt-card-list__tp2");
    const closed = container.querySelector(".mt-card-list__close");
  if(window.innerWidth >  999 ){
    container.addEventListener('mouseleave', (e) => {
        tp1.classList.remove("mt-card-un-visible");
        tp2.classList.remove("mt-card-un-visible");
    });
    tp1.addEventListener('mouseenter', (e) => {
        tp1.classList.add("mt-card-un-visible");
        tp2.classList.remove("mt-card-un-visible");
    });
    tp2.addEventListener('mouseenter', (e) => {
        tp1.classList.remove("mt-card-un-visible");
        tp2.classList.add("mt-card-un-visible");      
    });     
  }
     
    tp1.addEventListener('click', (e) => {
        tp1.classList.add("card_un_show");
        tp2.classList.add("card_un_show");
        container.querySelectorAll(".tp-img-1").forEach((item) => {  
          item.classList.remove("card_un_show");
        });  
        closed.classList.remove("card_un_show");
    });
    tp2.addEventListener('click', (e) => {
        tp1.classList.add("card_un_show");
        tp2.classList.add("card_un_show");
        container.querySelectorAll(".tp-img-2").forEach((item) => {  
          item.classList.remove("card_un_show");
        });
        closed.classList.remove("card_un_show");
    });

    container.querySelector(".mt-card-list__close").addEventListener('click', (e) => {
        tp1.classList.remove("card_un_show");
        tp2.classList.remove("card_un_show");
        closed.classList.add("card_un_show");
        container.querySelectorAll(".tp-img-1").forEach((item) => {  
          item.classList.add("card_un_show");
        });   
        container.querySelectorAll(".tp-img-2").forEach((item) => {  
          item.classList.add("card_un_show");
        });   
        
    });
});
/** mt-card-list **/
Array.from(document.querySelectorAll(".coupon-container")).forEach((container) => { 
    const endtime = document.querySelector(".coupon-end_time");
    var countdownEnd = new Date(endtime.innerText);

    function pad(n) { return n < 10 ? '0' + n : n; }

    function updateTimer() {
      var now = new Date();
      var diff = countdownEnd - now;//规避定时器不准
      if (diff < 0) diff = 0;
      var d = Math.floor(diff / (1000 * 60 * 60 * 24));
      var h = Math.floor((diff / (1000 * 60 * 60)) % 24);
      var m = Math.floor((diff / (1000 * 60)) % 60);
      var s = Math.floor((diff / 1000) % 60);
      document.getElementById('timer-days').textContent = pad(d);
      document.getElementById('timer-hours').textContent = pad(h);
      document.getElementById('timer-minutes').textContent = pad(m);
      document.getElementById('timer-seconds').textContent = pad(s);
    }
    setInterval(updateTimer, 1000);
    updateTimer();

  function showToast(msg) {
    var toast = document.getElementById('coupon-toast');
    toast.textContent = msg;
    toast.classList.add('show');
    setTimeout(function() {
      toast.classList.remove('show');
    }, 2000); // 2秒后自动消失
  }
  document.querySelector(".coupon-copy-btn-1").addEventListener('click', (e) => {
      var codeInput = document.getElementById('coupon-code-1');
      codeInput.select();//选中全部内容
      codeInput.setSelectionRange(0, 99999); // 兼容移动端，选中全部内容
      document.execCommand('copy');
      showToast('Coupon code copied!');
  });
  document.querySelector(".coupon-copy-btn-2").addEventListener('click', (e) => {
      var codeInput = document.getElementById('coupon-code-2');
      codeInput.select();//选中全部内容
      codeInput.setSelectionRange(0, 99999); // 兼容移动端，选中全部内容
      document.execCommand('copy');
      showToast('Coupon code copied!');
  });
});

